import React, { Fragment, Component } from 'react'
import {
    Row, Col,
    Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input,
    Collapse, ButtonGroup
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import Select from '../../../../../helpers/ui/CustomSelect'
import { FileInput, generateFormData } from '../../../../../helpers/ui/FileInput'
import { AvForm, AvField, } from "availity-reactstrap-validation"

import { withRouter } from "react-router-dom"
import apiResponse from '../../../../../services/apiResponse'

import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'
import IndexBloc from '../../Index/Blocs/IndexBloc_'
import CreateBloc from '../Blocs/CreateBloc'

const reformatDate = (date) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const d = new Date(date);
    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    if (date) {
        return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};

class CreateModal extends Component {

    indexBloc = new IndexBloc()
    createBloc = new CreateBloc()
    timer
    source
    defaultSize = 10

    constructor(props) {
        super(props)
        this.state = {
            selectedEmployee: null,
            detailMutasi: null,
            dataForm: null,
            employeeOption: [],
            workUnitOption: [],
            positionOption: [],
            selectedMinistry: 1,
            countryOption: [],
            pemberhentianType: null,
            type: null,
            employeeFilter: {
                filter_value: "",
                page_number: 1,
                page_size: this.defaultSize,
                sort_order: {
                    column: 'employee_id',
                    order: 'asc' 
                }
            },
            workUnitFilter: {
                filter_value: "",
                page_number: 1,
                page_size: this.defaultSize,
                sort_order: {
                    column: 'work_unit_id',
                    order: 'asc' 
                }
            },
            positionFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 9999,
                sort_order: {
                    column: 'position_id',
                    order: 'asc' 
                }
            },
            position_type: 1
        }
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.props.uuid,
                employee_transfer_detail_uuid: this.props.detailUuid,
                employee_transfer_detail_ministry: this.state.selectedMinistry,
                ...values
            },
            confirm: true
        })
    }

    loadEmployee  = async () => {
        let offset = (this.state.employeeFilter.page_number-1)*this.state.employeeFilter.page_size
        const query = {
            uuid: this.props.uuid,
            search: this.state.employeeFilter.filter_value,
            limit: this.state.employeeFilter.page_size,
            offset: offset,
            order: this.state.employeeFilter.sort_order.column,
            sort: this.state.employeeFilter.sort_order.order,
            status: 1
        }
        this.setState({ loadingEmployee: true })
        await this.indexBloc.fetchListPegawai(query)
    }

    loadWorkUnit = async () => {
        let offset = (this.state.workUnitFilter.page_number-1)*this.state.workUnitFilter.page_size
        const query = {
            search: this.state.workUnitFilter.filter_value,
            limit: this.state.workUnitFilter.page_size,
            offset: offset,
            order: this.state.workUnitFilter.sort_order.column,
            sort: this.state.workUnitFilter.sort_order.order,
            status: 1
        }
        this.setState({ loadingWorkUnit: true })
        await this.indexBloc.fetchListUnitKerja(query)
    }

    loadPosition = async (uuid) => {
        let offset = (this.state.positionFilter.page_number-1)*this.state.positionFilter.page_size
        const query = {
            uuid: uuid,
            search: this.state.positionFilter.filter_value,
            limit: this.state.positionFilter.page_size,
            offset: offset,
            order: this.state.positionFilter.sort_order.column,
            sort: this.state.positionFilter.sort_order.order,
            status: 1,
            position_type: this.state.position_type
        }
        this.setState({ loadingPosition: true })
        await this.indexBloc.fetchListJabatan(query)
    }

    loadRegion = async () => {
        const query = { type: 1 }
        await this.indexBloc.fetchRegion(query)
    }

    loadDetail = async (uuid) => {
        const query = {
            uuid: uuid
        }
        await this.indexBloc.fetchDetailMutasi(query)
    }

    submitData = async () => {
        const dataForm = generateFormData(this.state.dataForm, 'employee_transfer_detail_kemenlu_decree_document')
        if (this.props.uuid === '') {
            await this.createBloc.fetchCreate(dataForm)
        } else {
            await this.createBloc.fetchCreateDetail(dataForm)
        }
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }


    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadEmployee()
        this.loadWorkUnit()
        this.loadPosition('')
    }

    componentDidMount() {
        this.setTokenAPI()

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.props.setUuid(result.data.response.employee_transfer_uuid)
                    this.createBloc.fetchCreateDetail({ ...this.state.dataForm, uuid: result.data.response.employee_transfer_uuid })
                    break;
                default:
                    break;
            }
        })

        this.createBloc.createDetailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        this.setState({
                            loading: false,
                            success: true,
                        }, function() {
                            this.props.handleReload()
                        });
                    } else {
                        this.setState({
                            loading: false,
                            failed: true,
                        });
                    }
                    this.props.toggle()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.indexBloc.listPegawaiChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ employeeOption: result.data.response.result, loadingEmployee: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        });

        this.indexBloc.listUnitKerjaChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ workUnitOption: result.data.response.result, loadingWorkUnit: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        });

        this.indexBloc.listJabatanChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ positionOption: result.data.response.result, loadingPosition: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.detailMutasiChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let obj = this.state.employeeOption.find(o => o.employee_uuid === result.data.response.employee_transfer_detail_employee_uuid)
                    this.setState({ 
                        detailMutasi: result.data.response, 
                        selectedEmployee: obj,
                        type: result.data.response.employee_transfer_detail_type,
                        pemberhentianType: result.data.response.employee_transfer_detail_position_type,
                        selectedMinistry: result.data.response.employee_transfer_detail_ministry
                    })
                    break;
                case apiResponse.ERROR:
                    break
                default:
                    break;
            }
        })

        this.indexBloc.regionChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ countryOption: result.data.response.result, loadingCountry: false })
                    break;
                default:
                    break;
            }
        })

    }

    componentWillUnmount() {
        this.createBloc.createChannel?.unsubscribe()
        this.createBloc.createDetailChannel?.unsubscribe()
        this.indexBloc.listPegawaiChannel?.unsubscribe()
        this.indexBloc.listUnitKerjaChannel?.unsubscribe()
        this.indexBloc.listJabatanChannel?.unsubscribe()
        this.indexBloc.detailMutasiChannel?.unsubscribe()
        this.indexBloc.regionChannel?.unsubscribe()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.modal !== this.props.modal) {
            if (this.props.modal == false) {
                this.setState({ selectedEmployee: null, type: null, dataForm: null, detailMutasi: null })
            }
        }

        if (prevProps.detailUuid !== this.props.detailUuid) {
            if (this.props.detailUuid) {
                this.loadDetail(this.props.detailUuid)
            }
        }

        if (prevState.pemberhentianType !== this.state.pemberhentianType) {
            if (this.state.pemberhentianType == 2) {
                this.setState({ loadingCountry: true })
                this.loadRegion()
            }
        }
    }

    render() {
        const { selectedEmployee, type, detailMutasi } = this.state
        return (
            <Fragment>
                <Modal isOpen={this.props.modal} size='xl' centered={true} toggle={this.props.toggle}>
                    <ModalHeader toggle={this.props.toggle}>Tambah Mutasi Pegawai</ModalHeader>
                    <ModalBody>
                        <AvForm
                            className="needs-validation"
                            onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                        >
                            <Row className="mb-3">
                                <Label
                                    className="col-md-3 col-form-label"
                                >
                                    Jenis Mutasi <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                    <Select 
                                        name="employee_transfer_detail_type"
                                        options={[
                                            { value: 1, label: 'SK Pengangkatan Jabatan' },
                                            { value: 2, label: 'SK Pemberhentian & Pengangkatan Jabatan' },
                                            { value: 3, label: 'SK Pemberhentian Jabatan' },
                                        ]}
                                        onChange={opt => this.setState({ type: opt.value })}
                                        defaultValue={detailMutasi?.employee_transfer_detail_type}
                                        validate={{ required: { value: true } }}
                                    />
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Label
                                    className="col-md-3 col-form-label"
                                >
                                    Pegawai <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                    <Select 
                                        name="employee_transfer_detail_employee_uuid"
                                        options={this.state.employeeOption}
                                        optionLabel="employee_full_name"
                                        optionValue="employee_uuid"
                                        onChange={opt => this.setState({ selectedEmployee: opt })}
                                        onInputChange={value => { 
                                            if (value) {
                                                clearTimeout(this.timer)
                                                this.state.employeeFilter.filter_value = value
                                                this.timer = setTimeout(() => this.loadEmployee(), 1000);
                                            }
                                        }}
                                        isLoading={this.state.loadingEmployee}
                                        defaultValue={detailMutasi?.employee_transfer_detail_employee_uuid}
                                        validate={{ required: { value: true } }}
                                    />
                                </Col>
                           </Row>
                           <Collapse isOpen={selectedEmployee && true}>
                            { selectedEmployee != null &&
                                <Fragment>
                                    <Row className="mb-3 mt-3">
                                        <Label className="col-md-3 col-form-label">
                                            Nip
                                        </Label>
                                        <Col md="9">
                                            <Input
                                                value={selectedEmployee.employee_nip}
                                                type="text"
                                                readOnly={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Label className="col-md-3 col-form-label">
                                            Nama
                                        </Label>
                                        <Col md="9">
                                            <Input
                                                value={selectedEmployee.employee_full_name}
                                                type="text"
                                                readOnly={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                       <Label className="col-md-3 col-form-label">
                                            Pangkat
                                        </Label>
                                        <Col md="9">
                                            <Input
                                                value={selectedEmployee.employee_current_rank_group_room}
                                                type="text"
                                                readOnly={true}
                                            />
                                        </Col>
                                    </Row>
                                    { type == 1 &&
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">
                                                Unit Kerja
                                            </Label>
                                            <Col md="9">
                                                <Input
                                                    value={selectedEmployee.employee_current_work_unit_name}
                                                    type="textarea"
                                                    readOnly={true}
                                                />
                                            </Col>
                                        </Row>
                                    }
                                    <hr/>
                                </Fragment>
                            }
                           </Collapse>
                            
                            <Collapse isOpen={selectedEmployee && type == 1 && true}>
                            { selectedEmployee && type == 1 &&
                                <Fragment>
                                    <Label>Informasi Jabatan Baru</Label>
                                    <Row className="mb-3">
                                        <Label className="col-md-3 col-form-label">
                                        </Label>
                                        <Col md="9">
                                            <ButtonGroup>
                                                <Button type="button" color="primary" onClick={() => this.setState({ selectedMinistry: 1 })} active={this.state.selectedMinistry === 1}>Kementerian Di Dalam BKPM</Button>
                                                <Button type="button" color="primary" onClick={() => this.setState({ selectedMinistry: 2 })} active={this.state.selectedMinistry === 2}>Kementerian Di Luar BKPM</Button>
                                            </ButtonGroup>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-3 col-form-label"
                                        >
                                            Unit Kerja Baru <span className="text-danger">*</span>
                                        </Label>
                                        <Col md="9">
                                            { this.state.selectedMinistry === 1 ?
                                                <Select 
                                                    name="employee_transfer_detail_work_unit_uuid"
                                                    options={this.state.workUnitOption}
                                                    optionLabel="work_unit_name_reverse"
                                                    optionValue="work_unit_uuid"
                                                    errorMessage="Masukkan Unit Kerja Baru"
                                                    // onChange={opt => this.loadPosition(opt.work_unit_uuid)}
                                                    onInputChange={value => { 
                                                        if (value) {
                                                            clearTimeout(this.timer)
                                                            this.state.workUnitFilter.filter_value = value
                                                            this.timer = setTimeout(() => this.loadWorkUnit(), 1000);
                                                        }
                                                    }}
                                                    isLoading={this.state.loadingWorkUnit}
                                                    defaultValue={detailMutasi?.employee_transfer_detail_work_unit_uuid}
                                                    validate={{ required: { value: true } }}
                                                />                                           
                                            :
                                                <AvField
                                                    name="employee_transfer_detail_work_unit_name"
                                                    type="text"
                                                    placeholder="Unit Kerja Baru..."
                                                    validate={{ required: { value: true } }}
                                                    value={detailMutasi?.employee_transfer_detail_work_unit_name}
                                                />
                                            }
                                        </Col>
                                    </Row>
                                    { this.state.selectedMinistry === 1 &&
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-3 col-form-label"
                                            >
                                                Jenis Jabatan <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="9">
                                                    <Select 
                                                        name="position_type"
                                                        options={[
                                                            { value: 1, label: 'Struktural' }, 
                                                            { value: 2, label: 'Fungsional' },
                                                        ]}
                                                        errorMessage="Pilih Jabatan"
                                                        defaultValue={this.state.position_type}
                                                        onChange={opt => this.setState(
                                                            { 
                                                                position_type: opt.value 
                                                            }, 
                                                            () => this.loadPosition('')    
                                                        )}
                                                        validate={{ required: { value: true } }}
                                                    />
                                            </Col>
                                        </Row>
                                    }
                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-3 col-form-label"
                                        >
                                            Jabatan <span className="text-danger">*</span>
                                        </Label>
                                        <Col md="9">
                                            { this.state.selectedMinistry === 1 ?
                                                <Select 
                                                    name="employee_transfer_detail_position_uuid"
                                                    options={this.state.positionOption}
                                                    optionLabel="position_name"
                                                    optionValue="position_uuid"
                                                    errorMessage="Pilih Jabatan"
                                                    defaultValue={detailMutasi?.employee_transfer_detail_position_uuid}
                                                    // onInputChange={value => { 
                                                    //     if (value) {
                                                    //         clearTimeout(this.timer)
                                                    //         this.state.positionFilter.filter_value = value
                                                    //         this.timer = setTimeout(() => this.loadPosition(), 1000);
                                                    //     }
                                                    // }}
                                                    isLoading={this.state.loadingPosition}
                                                    validate={{ required: { value: true } }}
                                                />
                                            :
                                                <AvField
                                                    name="employee_transfer_detail_position_name"
                                                    type="text"
                                                    placeholder="Jabatan Baru..."
                                                    validate={{ required: { value: true } }}
                                                    value={detailMutasi?.employee_transfer_detail_position_name}
                                                />
                                            }
                                        </Col>
                                    </Row>
                                    { this.state.selectedMinistry !== 1 &&
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">
                                                Tunjangan Kinerja <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="9">
                                                <AvField 
                                                    name="employee_transfer_detail_allowance"
                                                    type="number"
                                                    placeholder="Tunjangan Kinerja..."
                                                    validate={{required: { value: true }}}
                                                    value={detailMutasi?.employee_transfer_detail_allowance}
                                                />
                                            </Col>
                                        </Row>
                                    }
                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-3 col-form-label"
                                        >
                                            No SK <span className="text-danger">*</span>
                                        </Label>
                                        <Col md="9">
                                            <AvField 
                                                name="employee_transfer_detail_decree_number"
                                                value={detailMutasi?.employee_transfer_detail_decree_number}
                                                placeholder="No SK..."
                                                type="text"
                                                errorMessage="Masukkan No SK"
                                                validate={{ required: { value: true } }}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-3 col-form-label"
                                        >
                                            Tanggal SK <span className="text-danger">*</span>
                                        </Label>
                                        <Col md="9">
                                            <AvField 
                                                name="employee_transfer_detail_decree_date"
                                                value={detailMutasi?.employee_transfer_detail_decree_date}
                                                placeholder="Tanggal SK..."
                                                type="date"
                                                errorMessage="Masukkan Tanggal SK"
                                                validate={{ required: { value: true } }}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-3 col-form-label"
                                        >
                                            TMT Jabatan <span className="text-danger">*</span>
                                        </Label>
                                        <Col md="9">
                                            <AvField 
                                                name="employee_transfer_detail_tmt_date"
                                                value={detailMutasi?.employee_transfer_detail_tmt_date}
                                                placeholder="TMT Jabatan..."
                                                type="date"
                                                errorMessage="Masukkan TMT Jabatan"
                                                validate={{ required: { value: true } }}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-3 col-form-label"
                                        >
                                            Pejabat Penetap <span className="text-danger">*</span>
                                        </Label>
                                        <Col md="9">
                                            <AvField 
                                                name="employee_transfer_detail_signatories_official"
                                                value={detailMutasi?.employee_transfer_detail_signatories_official}
                                                placeholder="Pejabat Penetap..."
                                                type="text"
                                                errorMessage="Masukkan Pejabat Penetap"
                                                validate={{ required: { value: true } }}
                                            />
                                        </Col>
                                    </Row>
                                </Fragment>
                            }
                            </Collapse>

                            <Collapse isOpen={selectedEmployee && (type == 2 || type == 3) && true}>
                            { selectedEmployee && (type == 2 || type == 3) && 
                                <Fragment>
                                    <Label>Informasi Jabatan Lama</Label>
                                    <Row className="mb-3">
                                       <Label className="col-md-3 col-form-label">
                                            Unit Kerja
                                        </Label>
                                        <Col md="9">
                                            <AvField 
                                                name="employee_transfer_detail_old_work_unit_uuid"
                                                type="hidden"
                                                value={selectedEmployee.employee_current_work_unit_uuid}
                                            />
                                            <Input
                                                value={selectedEmployee.employee_current_work_unit_name}
                                                type="textarea"
                                                readOnly={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                       <Label className="col-md-3 col-form-label">
                                            Jabatan
                                        </Label>
                                        <Col md="9">
                                            <AvField 
                                                name="employee_transfer_detail_old_position_uuid"
                                                type="hidden"
                                                value={selectedEmployee.employee_current_position_uuid}
                                            />
                                            <Input
                                                value={selectedEmployee.employee_current_position_name}
                                                type="text"
                                                readOnly={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                       <Label className="col-md-3 col-form-label">
                                            Tanggal SK Lama
                                        </Label>
                                        <Col md="9">
                                            <AvField 
                                                name="employee_transfer_detail_old_decree_date"
                                                type="hidden"
                                                value={selectedEmployee.sk_jabatan?.position_history_decree_date}
                                            />
                                            <Input
                                                value={reformatDate(selectedEmployee.sk_jabatan?.position_history_decree_date)}
                                                type="text"
                                                readOnly={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                       <Label className="col-md-3 col-form-label">
                                            No SK Lama
                                        </Label>
                                        <Col md="9">
                                            <AvField 
                                                name="employee_transfer_detail_old_decree_number"
                                                type="hidden"
                                                value={selectedEmployee.sk_jabatan?.position_history_decree_number}
                                            />
                                            <Input
                                                value={selectedEmployee.sk_jabatan?.position_history_decree_number}
                                                type="text"
                                                readOnly={true}
                                            />
                                        </Col>
                                    </Row>
                                    <hr/>
                                    <Label>Informasi Jabatan Baru</Label>
                                    { type == 2 &&
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">
                                            </Label>
                                            <Col md="9">
                                                <ButtonGroup>
                                                    <Button type="button" color="primary" onClick={() => this.setState({ selectedMinistry: 1 })} active={this.state.selectedMinistry === 1}>Kementerian Di Dalam BKPM</Button>
                                                    <Button type="button" color="primary" onClick={() => this.setState({ selectedMinistry: 2 })} active={this.state.selectedMinistry === 2}>Kementerian Di Luar BKPM</Button>
                                                </ButtonGroup>
                                            </Col>
                                        </Row>
                                    }
                                    { type == 3 &&
                                        <>
                                            <Row className="mb-3">
                                                <Label className="col-md-3 col-form-label">
                                                    Alasan Pemberhentian <span className="text-danger">*</span>
                                                </Label>
                                                <Col md="9">
                                                    <Select 
                                                        name="employee_transfer_detail_stop_cause"
                                                        placeholder="Alasan Pemberhentian..."
                                                        errorMessage="Masukkan Alasan Pemberhentian"
                                                        defaultValue={detailMutasi?.employee_transfer_detail_stop_cause}
                                                        validate={{ required: { value: true } }}
                                                        options={[
                                                            { value: 1, label: 'Tugas Belajar' }, 
                                                            { value: 2, label: 'Ditugaskan Di Luar Negeri/Luar BKPM' }, 
                                                            { value: 3, label: 'Pindah Instansi' }, 
                                                            { value: 4, label: 'Pensiun' },
                                                            { value: 5, label: 'Cuti di Luar Tanggunan Negara' },
                                                            { value: 6, label: 'Meninggal Dunia' },
                                                            { value: 7, label: 'Resign / Mengundurkan diri'},
                                                        ]}
                                                        onChange={opt => this.setState({ pemberhentianType: opt.value })}
                                                    />
                                                </Col>
                                            </Row>

                                            {
                                                this.state.pemberhentianType == 1 && // Tugas Belajar
                                                <>
                                                    <Row className="mb-3">
                                                        <Label
                                                            className="col-md-3 col-form-label"
                                                        >
                                                            Tanggal Mulai Belajar<span className="text-danger">*</span>
                                                        </Label>
                                                        <Col md="9">
                                                            <AvField 
                                                                name="employee_transfer_detail_study_start_date"
                                                                value={detailMutasi?.employee_transfer_detail_study_start_date}
                                                                placeholder="Tanggal Mulai Belajar..."
                                                                type="date"
                                                                errorMessage="Masukkan Tanggal Mulai Belajar"
                                                                validate={{ required: { value: true } }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-3">
                                                        <Label
                                                            className="col-md-3 col-form-label"
                                                        >
                                                            Tanggal Selesai Belajar<span className="text-danger">*</span>
                                                        </Label>
                                                        <Col md="9">
                                                            <AvField 
                                                                name="employee_transfer_detail_study_end_date"
                                                                value={detailMutasi?.employee_transfer_detail_study_end_date}
                                                                placeholder="Tanggal Selesai Belajar..."
                                                                type="date"
                                                                errorMessage="Masukkan Tanggal Selesai Belajar"
                                                                validate={{ required: { value: true } }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </>
                                            }

                                            {
                                                this.state.pemberhentianType == 6 && // Meninggal Dunia
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-3 col-form-label"
                                                    >
                                                        Tanggal Meninggal Dunia<span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="9">
                                                        <AvField 
                                                            name="employee_transfer_detail_date_of_death"
                                                            value={detailMutasi?.employee_transfer_detail_date_of_death}
                                                            placeholder="Tanggal Meninggal Dunia..."
                                                            type="date"
                                                            errorMessage="Masukkan Tanggal Meninggal Dunia"
                                                            validate={{ required: { value: true } }}
                                                        />
                                                    </Col>
                                                </Row>
                                            }

                                        </>
                                    }
                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-3 col-form-label"
                                        >
                                            Unit Kerja Baru <span className="text-danger">*</span>
                                        </Label>
                                        <Col md="9">
                                            { this.state.selectedMinistry === 1 ?
                                                <Select 
                                                    name="employee_transfer_detail_work_unit_uuid"
                                                    defaultValue={detailMutasi?.employee_transfer_detail_work_unit_uuid}
                                                    options={this.state.workUnitOption}
                                                    optionLabel="work_unit_name_reverse"
                                                    optionValue="work_unit_uuid"
                                                    errorMessage="Masukkan Unit Kerja Baru"
                                                    // onChange={opt => this.loadPosition(opt.work_unit_uuid)}
                                                    onInputChange={value => { 
                                                        if (value) {
                                                            clearTimeout(this.timer)
                                                            this.state.workUnitFilter.filter_value = value
                                                            this.timer = setTimeout(() => this.loadWorkUnit(), 1000);
                                                        }
                                                    }}
                                                    isLoading={this.state.loadingWorkUnit}
                                                    validate={{ required: { value: true } }}
                                                />
                                            :
                                                <AvField 
                                                    name="employee_transfer_detail_work_unit_name"
                                                    placeholder="Masukkan Unit Kerja..."
                                                    type="text"
                                                    validate={{ required: { value: true } }}
                                                    value={detailMutasi?.employee_transfer_detail_work_unit_name}
                                                />
                                            }
                                        </Col>
                                    </Row>
                                    {/* { type == 2 && */}
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-3 col-form-label"
                                            >
                                                Jenis Jabatan <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="9">
                                                    <Select 
                                                        name="position_type"
                                                        options={[
                                                            { value: 1, label: 'Struktural' }, 
                                                            { value: 2, label: 'Fungsional' },
                                                        ]}
                                                        errorMessage="Pilih Jabatan"
                                                        defaultValue={this.state.position_type}
                                                        onChange={opt => this.setState(
                                                            { 
                                                                position_type: opt.value 
                                                            }, 
                                                            () => this.loadPosition('')    
                                                        )}
                                                        validate={{ required: { value: true } }}
                                                    />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-3 col-form-label"
                                            >
                                                Jabatan <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="9">
                                                <Select 
                                                    name="employee_transfer_detail_position_uuid"
                                                    defaultValue={detailMutasi?.employee_transfer_detail_position_uuid}
                                                    options={this.state.positionOption}
                                                    optionLabel="position_name"
                                                    optionValue="position_uuid"
                                                    errorMessage="Pilih Jabatan"
                                                    isLoading={this.state.loadingPosition}
                                                    validate={{ required: { value: true } }}
                                                />    
                                            </Col>
                                        </Row>
                                    {/* } */}
                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-3 col-form-label"
                                        >
                                            No SK {this.state.pemberhentianType == 2 ? 'Kemenlu' : ''}<span className="text-danger">*</span>
                                        </Label>
                                        <Col md="9">
                                            <AvField 
                                                name="employee_transfer_detail_decree_number"
                                                value={detailMutasi?.employee_transfer_detail_decree_number}
                                                placeholder="No SK..."
                                                type="text"
                                                errorMessage="Masukkan No SK"
                                                validate={{ required: { value: true } }}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-3 col-form-label"
                                        >
                                            Tanggal SK {this.state.pemberhentianType == 2 ? 'Kemenlu' : ''}<span className="text-danger">*</span>
                                        </Label>
                                        <Col md="9">
                                            <AvField 
                                                name="employee_transfer_detail_decree_date"
                                                value={detailMutasi?.employee_transfer_detail_decree_date}
                                                placeholder="Tanggal SK..."
                                                type="date"
                                                errorMessage="Masukkan Tanggal SK"
                                                validate={{ required: { value: true } }}
                                            />
                                        </Col>
                                    </Row>
                                    { (type == 2 || type == 3) &&
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-3 col-form-label"
                                            >
                                                TMT <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="9">
                                                <AvField 
                                                    name="employee_transfer_detail_tmt_date"
                                                    value={detailMutasi?.employee_transfer_detail_tmt_date}
                                                    placeholder="TMT..."
                                                    type="date"
                                                    errorMessage="Masukkan TMT"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                    }
                                    { type == 3 &&
                                        <Fragment>
                                            { this.state.pemberhentianType === 2 &&
                                                <Fragment>
                                                    <Row className="mb-3">
                                                        <Label className="col-md-3 col-form-label">
                                                            Jenis Jabatan <span className="text-danger">*</span>
                                                        </Label>
                                                        <Col md="9">
                                                            <Select 
                                                                name="employee_transfer_detail_position_type"
                                                                placeholder="Jenis Jabatan..."
                                                                errorMessage="Pilih Jenis Jabatan"
                                                                defaultValue={detailMutasi?.employee_transfer_detail_position_type}
                                                                validate={{ required: { value: true } }}
                                                                options={[
                                                                    { value: 1, label: 'Pejabat Promosi Investasi' }, 
                                                                    { value: 2, label: 'Pembantu Pejabat Promosi Investasi' }, 
                                                                ]}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-3">
                                                        <Label className="col-md-3 col-form-label">
                                                            Negara Penempatan <span className="text-danger">*</span>
                                                        </Label>
                                                        <Col md="9">
                                                            <Select 
                                                                name="employee_transfer_detail_country_uuid"
                                                                optionLabel="region_name"
                                                                optionValue="region_uuid"
                                                                placeholder="Negara Penempatan..."
                                                                errorMessage="Pilih Negara Penempatan"
                                                                defaultValue={detailMutasi?.employee_transfer_detail_country_uuid}
                                                                validate={{ required: { value: true } }}
                                                                options={this.state.countryOption}
                                                                isLoading={this.state.loadingCountry}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Fragment>
                                            }
                                        </Fragment>
                                    }
                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-3 col-form-label"
                                        >
                                            Pejabat Penetap <span className="text-danger">*</span>
                                        </Label>
                                        <Col md="9">
                                            <AvField 
                                                name="employee_transfer_detail_signatories_official"
                                                value={detailMutasi?.employee_transfer_detail_signatories_official}
                                                placeholder="Pejabat Penetap..."
                                                type="text"
                                                errorMessage="Masukkan Pejabat Penetap"
                                                validate={{ required: { value: true } }}
                                            />
                                        </Col>
                                    </Row>
                                    { type == 3 && this.state.pemberhentianType == 2 &&
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">
                                                Upload SK Kemenlu <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <FileInput 
                                                    name="employee_transfer_detail_kemenlu_decree_document" 
                                                    col={6} 
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                    }
                                </Fragment>
                            }
                            </Collapse>
                        
                            <ModalFooter>
                                <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>{' '}
                                <Button color="primary" type="submit">Submit</Button>
                            </ModalFooter>
                        </AvForm>
                    </ModalBody>
                </Modal>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"
                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />

            </Fragment>
        )
    }
}

export default withRouter(CreateModal)